<template>
  <a
    :class="$style.root"
    :href="item?.url"
    target="_blank"
  >
    <div>
      <div
        v-if="label"
        :class="$style.label"
      >
        {{ label }}
      </div>

      <CoreTextComponent
        v-if="description"
        :string="description"
      />
    </div>

    <LayoutHorizontalLineComponent />
  </a>
</template>

<script setup>
const props = defineProps({
  item: Object
})

const label = computed(() => {
  return props?.item?.labels?.current_locale
})

const description = computed(() => {
  return props?.item?.descriptions?.current_locale
})
</script>

<style module>
.root {
  composes: reset-link container--default from global;


  display: flex;
  flex-direction: column;
  gap: var(--unit--spacer);

  text-align: center;
}

.root:hover {
  color: var(--color--accent);
}

.label {
  text-transform: uppercase;
}
</style>
